var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 33.333332,
    height: 33.333332,
    viewBox: "0 0 33.333332 33.333332",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("image", {
    width: 33.333332,
    height: 33.333332,
    preserveAspectRatio: "none",
    style: {
      imageRendering: "optimizeQuality"
    },
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC\n8ElEQVRIS6XWS2geVRTA8d91xlAoFLoJCFLRjQsLH0KtjQ8UrVLT+EAX8UHwsVCqlkrBIIpKu4yp\nr9KFtmDEB2ajVNuAK2NdNIt20WUWbroRs8mqElI+rosz82Uyfvli6R8G5t5z7j1z5txzzi0NIOe8\nBWPYj13Yga24gsu4gDn8klJaqde1KdsTkHMewkFMYrglhm3YWT0vYSnnPIXjKaXVpiJ9jOScb8cs\nOm3ZAIYxjYmc83hKabEpXGck57xHuL+9OX8NdHA+5zyaUlqoJ3tGKg+ux0DNdszlnEdqj0p6MZit\nFK7iFfxdr8L9eL8xbvMnDuMT3Cb2mc05704prdaeHLQWgxvxIp7CjFjwBu7A05VOk7+wDx8IAzUd\nse+xsjqmkw0h7BVf9jV+Fl7uw524taG3XM2/iYnGfM1kzvlE2e12Hy+Kot8x/VAYm8bbOIJn8QeG\ncs7/pJTG8CQO9VatZxhjZVEUo21JRYHvcRfuw6v4TXg9lVJ6Rnh2tLeiP/tLkckbcRO+wvO4iC+F\n/oL4/5+vqW7IrlKUikE8ghdEZp8W8bkX3+CGNbUN2VGKWrQZR/CwOKKHVdmNcxhq6PVjaymK3ba2\npEWBh/CO8OIA5qvxx2tqfblSimq6sy1pMYNvcRLPificFPF5EE/Uin24XIpyPcjIaXGc50WOLOJl\n/IQfRCvo4JZKv82FEmdFUPsxj9fxq7UkPCp+3Wd4C++J/DknqkWbsyXOYMl/+8ZFcXR/tN7TUuTP\n3bhHlJzf8S4+augR+54pU0orVcOZbggXRSbPYE9jvuZmnBLx+UJ8zAQeEL+vZiqltFJWg+NCqYNV\n8UWf4tFK3o/H8BqmqvFIt9v9riiKvdiCS2LfKPUppdWc8zjOi6p7qlq4GZPVA4qiqF+XMV634toT\nKaXFnPOo629cyxhttuCeEUgpLeScR1x7j6+5JDzoGaDPRaLyaLfBt5U2SyI2/++2QsQIx3LOJ2xy\n7+p2u3NFUQy8d/0L/mbREK74as8AAAAASUVORK5CYII=\n",
    id: "image1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXWhite);
export default __webpack_public_path__ + "static/media/x_white.61deec2538ba405f1365e6cc34081e13.svg";
export { ForwardRef as ReactComponent };